var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lay-overtime"},[_c('mt-cell',{attrs:{"title":"出勤天数","value":(_vm.signNum || 0)+'天'}}),_vm._v(" "),_c('mt-cell',{attrs:{"title":"迟到","value":(_vm.lateNum || 0)+'次'}}),_vm._v(" "),_c('mt-cell',{attrs:{"title":"早退","value":(_vm.earlyNum || 0)+'次'}}),_vm._v(" "),_c('mt-cell',{attrs:{"title":"缺卡","value":(_vm.lackNum || 0)+'次'}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84c126b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/layOvertime.vue
// module id = kqeE
// module chunks = 0